import Vuex from 'vuex';
import Vue from 'vue';

import axios from 'axios';
import constants from '@/api';
import moment from 'moment-timezone';

import fileExtraction from './views/file-extraction/store';
import extractedData from './views/extracted-data/store';
import rejectedMeta from './views/rejected-meta/store';
import fileMeta from './views/file-meta/store';
import rejectedMetaTwo from './views/reject-meta-two/store';
import reworkExtractedData from './views/rework-extracted-data/store';
import requests from './views/requests/store';
import stockist from './views/stockist-mapping/store';
import identifyStockist from './views/identify-stockist/store';

Vue.use(Vuex);
const initialState = () => ({
	startDay: 25,
	selectedDates: [],
	loaderDialog: false,
	snackbarState: false,
	snackbarText: '',
	snackbarColor: undefined,
	snackbarTime: 2000,
	userType: '',
	authToken: '',
	auth: false,
	userData: {},
	messages: {
		loginFailed: '',
		failure: '',
	},
	extensions: ['PDF', 'XLSX', 'TXT', 'CSV', 'HTML'],
	mapableHeaders: [
		'',
		'PRODUCT_NAME',
		'PACKING',
		'OPENING',
		'PURCHASE',
		'PURCHASE_FREE',
		'PURCHASE_RETURN',
		'SALES',
		'SALES_FREE',
		'SALES_RETURN',
		'CLOSING',
		'BATCH_NO',
		'ADJUSTMENT',
		'ADJUSTMENT_PLUS',
		'ADJUSTMENT_MINUS',
		'OPENING_VALUE',
		'PURCHASE_VALUE',
		'SALES_VALUE',
		'CLOSING_VALUE',
		'DIST_SALE',
		'RATE',
	],
	rejectRemarks: [
		{ text: 'All', value: false },
		// ...require("./components/rejects.json")
		'ERROR_PURCHASE_ORDER',
		'ERROR_MISSING_HEADERS',
		'ERROR_INVALID_DATA_ROWS',
		'ERROR_UNABLE_TO_EXTRACT',
		'ERROR_UNALIGNED_HEADERS',
		'ERROR_TXT_TO_XLS',
		'ERROR_JS_RENDERING',
		'ERROR_XLS_TO_PDF',
		'ERROR_UNALIGNED_DATA',
		'ERROR_XLS_MERGED_HEADERS',
		'ERROR_INVALID_XLS',
		'ERROR_INVALID_PDF',
		'ERROR_MULTILINE_PRODUCT',
		'ERROR_TXT_TO_PDF',
		'ERROR_MISSING_DATA',
		'ERROR_XLS_MERGED_DATA',
		'ERROR_MERGED_HEADERS',
		'ERROR_MULTILINE_DATA',
		'ERROR_UNALINED_HEADERS',
		'ERROR_INVALID_PDF_OBJECTS',
		'ERROR_XLS_MULTISHEET',
		'ERROR_TAX_INVOICE',
		'ERROR_PDF_IMAGE_OBJECTS',
		'ERROR_MERGED_CELLS',
		'ERROR_MERGED_DATA',
		'ERROR_MULTILINE_HEADERS',
		'ERROR_TXT_TO_PDF',
		'ERROR_CALCULATION_MISMATCH',
		'ERROR_MULTILINE_PRODUCT_NAME',
		'ERROR_PDF_TO_XLS',
		'CONVERTABLE',
		'MULTI_PAGE_PDF',
		'ERROR_SPECIAL_CHARACTER',
		'PDF_TABLES_CONVERTABLE',
		'ERROR_STATEMENT_VALIDITY',
		'PYTHON_SCRIPT_CONVERTABLE',
		'PYTHON_SCRIPT_DELIMITER_CONVERTABLE',
		"PDF_ML_MODEL_CONVERTABLE",
		'PDF_ML_MODEL_HEADERS_CONVERTABLE',
		'PDF_GEMINI_CONVERTABLE',
		'XLS_TO_XLSX_CONVERTABLE',
		'ERROR_FILE_NOT_RECEIVED_FROM_STOCKIEST',
		// "ERROR_TXT_TO_PDF",
		// "ERROR_PDF_TO_XLS",
		// "ERROR_CALCULATION_MISMATCH",
		// "ERROR_JS_RENDERING",
		// "ERROR_MISSING_HEADERS",
		// "ERROR_INVALID_DATA_ROWS",
		// "ERROR_UNALIGNED_HEADERS",
		// "ERROR_UNALIGNED_DATA",
		// "ERROR_XLS_MERGED_DATA",
		// "ERROR_XLS_MERGED_HEADERS",
		// "ERROR_REJECT_UNMARKED",
		// "ERROR_INVALID_PDF",
		// "ERROR_MULTILINE_DATA",
		// "ERROR_MISSING_DATA",
		// "ERROR_XLS_MULTISHEET",
		// "ERROR_ONLY_SALES_CLOSING",
		// "ERROR_PURCHASE_ORDER",
		// "ERROR_TXT_TO_XLS",
		// "ERROR_INVALID_XLS",
		// "ERROR_MULTILINE_PRODUCT",
		// "ERROR_PDF_IMAGE_OBJECTS"
	],
});

export default new Vuex.Store({
	strict: true,
	modules: {
		fileExtraction,
		extractedData,
		rejectedMeta,
		fileMeta,
		rejectedMetaTwo,
		reworkExtractedData,
		requests,
		stockist,
		identifyStockist,
	},
	state: initialState(),
	mutations: {
		setSelectedDates(s, dates) {
			s.selectedDates = dates;
		},
		openLoaderDialog(s) {
			s.loaderDialog = true;
		},
		closeLoaderDialog(s) {
			s.loaderDialog = false;
		},
		openSnackbar(s, { text, time = 3000, color = undefined }) {
			s.snackbarTime = time;
			s.snackbarText = text;
			s.snackbarState = true;
			s.snackbarColor = color;
		},
		closeSnackbar(s) {
			s.snackbarState = false;
		},
		failure: (s, p) => {
			s.messages.failure = p;
		},
		typeTenLogin: (state, data) => {
			state.authToken = data.token ? data.token : true;
			state.auth = !!data.token;
			state.userType = 10;
			state.userData = data.userData;
			sessionStorage.setItem('userType', 10);
			sessionStorage.setItem('auth', data.token);
			// sessionStorage.setItem('tenant', data.tenant);
		},
		typeThirtyLogin: (state, data) => {
			state.authToken = data.token ? data.token : true;
			state.auth = !!data.token;
			state.userType = 30;
			state.userData = data.userData;
			sessionStorage.setItem('userType', 30);
			sessionStorage.setItem('auth', data.token);
			// sessionStorage.setItem('tenant', data.tenant);
		},
		loginFail: (s, p) => {
			s.messages.loginFailed = p;
		},
	},
	actions: {
		apiCallWithHeaderConfig({ commit, state }, { partConfig, headerConfig }) {
			return new Promise((resolve, reject) => {
				if (!state.auth) {
					throw 'no auth token found';
				}
				axios({
					...partConfig,
					headers: {
						...headerConfig,
						Authorization: state.authToken,
					},
				})
					.then(response => {
						// console.log(response)
						let data = response.data;
						resolve(data);
					})
					.catch(err => {
						console.log('[HTTP API Request Error]', err);
						if (err.message == 'Network Error') {
							commit('openSnackbar', { text: 'Network Error' });
							// console.log("Network Error");
						} else {
							commit('openSnackbar', {
								text: 'Check console for Error',
							});
						}
						reject({
							ok: false,
							message: 'Error connecting to SSE server',
						});
					});
			});
		},
		apiCall({ commit, state }, partConfig) {
			return new Promise((resolve, reject) => {
				if (!state.auth) {
					throw 'no auth token found';
				}
				axios({
					...partConfig,
					headers: {
						Authorization: state.authToken,
					},
				})
					.then(response => {
						// console.log(response)
						let data = response.data;
						resolve(data);
					})
					.catch(err => {
						console.log('[HTTP API Request Error]', err);
						if (err.message == 'Network Error') {
							commit('openSnackbar', { text: 'Network Error' });
							// console.log('Network Error');
						} else {
							commit('openSnackbar', {
								text: 'Check console for Error',
							});
						}
						reject({
							ok: false,
							message: 'Error connecting to SSE server',
						});
					});
			});
		},
		fileDownload_API_Call({ state }, partConfig) {
			return new Promise((resolve, reject) => {
				if (!state.auth) {
					throw 'no auth token found';
				}
				axios({
					...partConfig,
					headers: {
						Authorization: state.authToken,
					},
					onDownloadProgress: progressEvent => {
						// console.log(progressEvent);
						// console.log((progressEvent.loaded * 100)/progressEvent.total);
					},
				})
					.then(response => {
						let data = response.data;
						resolve({ data, response });
					})
					.catch(err => {
						console.log('[HTTP API Request Error]', err);
						if (err.message == 'Network Error') {
							// commit("openSnackbar", "Network Error");
						}
						reject({
							ok: false,
							message: 'Error connecting to KBET',
						});
					});
			});
		},
		downloadFileWiseExtractionPercentage: (
			{ commit, dispatch },
			{ month, year }
		) => {
			let fail = msg => commit('failure', msg);
			return dispatch('fileDownload_API_Call', {
				method: 'get',
				params: {
					month,
					year,
				},
				url: constants.UTILITY_GET_FILE_WISE_EXTRACTION_PERCENTAGE,
				responseType: 'blob',
			})
				.then(({ data, response }) => {
					if (response.status === 200) {
						commit('openSnackbar', { text: 'Starting Download' });
						const url = window.URL.createObjectURL(new Blob([data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute(
							'download',
							'FWEP for ' + month + '-' + year + '.csv'
						);
						document.body.appendChild(link);
						link.click();
						return;
					} else {
						commit(
							'openSnackbar',
							{ text: 'Could not start download' },
							{ root: true }
						);
						fail(data.message || 'Failed to start download');
						return;
					}
				})
				.catch(err => {
					console.log('download err ', err);
					commit(
						'openSnackbar',
						{ text: 'Could not start download' },
						{ root: true }
					);
					fail(err.toString() || 'Failed to Download Core Data File');
				});
		},
		downloadExtractedData: ({ commit, dispatch }, { month, year, dates }) => {
			let fail = msg => commit('failure', msg);
			return dispatch('fileDownload_API_Call', {
				method: 'get',
				params: {
					month,
					year,
					...(dates && dates),
				},
				url: constants.UTILITY_GET_EXTRACTED_DATA,
				responseType: 'blob',
			})
				.then(({ data, response }) => {
					if (response.status === 200) {
						commit('openSnackbar', { text: 'Starting Download' });
						const url = window.URL.createObjectURL(new Blob([data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', month + '-' + year + '.csv');
						document.body.appendChild(link);
						link.click();
						return;
					} else {
						commit(
							'openSnackbar',
							{ text: 'Could not start download' },
							{ root: true }
						);
						fail(data.message || 'Failed to start download');
						return;
					}
				})
				.catch(err => {
					console.log('download err ', err);
					commit(
						'openSnackbar',
						{ text: 'Could not start download' },
						{ root: true }
					);
					fail(err.toString() || 'Failed to Download Core Data File');
				});
		},
		downloadMailLog: ({ commit, dispatch }, dates) => {
			let fail = msg => commit('failure', msg);
			return dispatch('fileDownload_API_Call', {
				method: 'get',
				params: dates,
				url: constants.UTILITY_GET_MAIL_LOG,
				responseType: 'blob',
			})
				.then(({ data, response }) => {
					if (response.status === 200) {
						commit('openSnackbar', { text: 'Starting Download' });
						const url = window.URL.createObjectURL(new Blob([data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', 'mail-log.csv');
						document.body.appendChild(link);
						link.click();
						return;
					} else {
						commit(
							'openSnackbar',
							{ text: 'Could not start download' },
							{ root: true }
						);
						fail(data.message || 'Failed to start download');
						return;
					}
				})
				.catch(err => {
					console.log('download err ', err);
					commit(
						'openSnackbar',
						{ text: 'Could not start download' },
						{ root: true }
					);
					fail(err.toString() || 'Failed to Download Core Data File');
				});
		},
		downloadFile: ({ commit, dispatch }, file) => {
			let fail = msg => commit('failure', msg);
			return dispatch('fileDownload_API_Call', {
				method: 'get',
				params: {},
				url: constants.UTILITY_OG_FILE + '?uuid=' + file.split('.')[0],
				responseType: 'blob',
			})
				.then(({ data, response }) => {
					if (response.status === 200) {
						commit('openSnackbar', { text: 'Starting Download' });
						const url = window.URL.createObjectURL(new Blob([data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', file); //or any other extension
						document.body.appendChild(link);
						link.click();
						return;
					} else {
						commit(
							'openSnackbar',
							{ text: 'Could not start download' },
							{ root: true }
						);
						fail(data.message || 'Failed to start download');
						return;
					}
				})
				.catch(err => {
					console.log('download err ', err);
					commit(
						'openSnackbar',
						{ text: 'Could not start download' },
						{ root: true }
					);
					fail(err.toString() || 'Failed to Download Core Data File');
				});
		},
		modelInputUpload: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCallWithHeaderConfig',
				{
					partConfig: {
						method: 'post',
						data: payload,
						url: constants.UPLOAD_MODEL_INPUT,
					},
					headerConfig: {
						'Content-Type': 'multipart/form-data',
					},
				},
				{ root: true }
			)
				.then(data => {
					if (data.ok) {
						return data;
					} else {
						fail(data.message || 'Failed to upload file');
						return data;
					}
				})
				.catch(err => {
					// console.log('Yo ', err);
					fail(err.toString() || 'Failed to upload file');
				});
		},
		adminLogin: ({ commit }, payload) => {
			let fail = msg => commit('loginFail', msg);
			if (!payload.username || !payload.password) {
				fail('No username/pw provided');
				return;
			}
			let { username, password } = payload;
			axios
				.post(constants.LOGIN, { username, password })
				.then(response => {
					let data = response.data;
					if (!data.ok) {
						fail(data.message || 'Login Failed');
					} else if (data.mortal.type === 30) {
						/* logical success */
						commit('typeTenLogin', {
							token: data.token,
							/* tenant: data.mortal.tenant, */ userData: data.mortal.userData,
						});
					} else {
						/* logical error */
						fail('Not valid usertype');
					}
				})
				.catch(err => {
					console.log('[Error] login', err);
					if (err.message == 'Network Error') {
						fail('Network Error');
					} else {
						fail('Login Failed');
					}
				});
		},
		login: ({ commit }, payload) => {
			let fail = msg => commit('loginFail', msg);
			if (!payload.username || !payload.password) {
				fail('No username/pw provided');
				return;
			}
			let { username, password } = payload;
			axios
				.post(constants.LOGIN, { username, password })
				.then(response => {
					let data = response.data;
					if (!data.ok) {
						fail(data.message || 'Login Failed');
					} else if (data.mortal.type === 10) {
						/* logical success */
						commit('typeTenLogin', {
							token: data.token,
							/* tenant: data.mortal.tenant, */ userData: data.mortal.userData,
						});
					} else if (data.mortal.type === 30) {
						/* logical success */
						commit('typeThirtyLogin', {
							token: data.token,
							/* tenant: data.mortal.tenant, */ userData: data.mortal.userData,
						});
					} else {
						/* logical error */
						fail('Not valid usertype');
					}
				})
				.catch(err => {
					console.log('[Error] login', err);
					if (err.message == 'Network Error') {
						fail('Network Error');
					} else {
						fail('Login Failed');
					}
				});
		},
		getOverallSummary: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch('apiCall', {
				method: 'get',
				params: payload,
				url: constants.UTILITY_GET_OVERALL_SUMMARY,
			})
				.then(data => {
					if (data.ok) {
						return data;
					} else {
						fail(data.message || 'Failed to load overall summary');
						return { ok: false };
					}
				})
				.catch(err => {
					console.log('stats load ', err);
					fail(err.toString() || 'Failed to load Overall summary');
				});
		},
		getStockistWiseSummary: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch('apiCall', {
				method: 'get',
				params: payload,
				url: constants.UTILITY_GET_STOCKIST_WISE_SUMMARY,
			})
				.then(data => {
					if (data.ok) {
						return data;
					} else {
						fail(data.message || 'Failed to load overall summary');
						return { ok: false };
					}
				})
				.catch(err => {
					console.log('stats load ', err);
					fail(err.toString() || 'Failed to load stockist summary');
				});
		},
		getCreatorWiseMetaCount: ({ commit, dispatch } /* payload */) => {
			let fail = msg => commit('failure', msg);
			return dispatch('apiCall', {
				method: 'get',
				params: {
					/* payload */
				},
				url: constants.UTILITY_GET_CREATOR_WISE_META_COUNT,
			})
				.then(data => {
					if (data.ok) {
						return data;
					} else {
						fail(data.message || 'Failed to load creator wise analytics');
						return { ok: false };
					}
				})
				.catch(err => {
					console.log('stats load ', err);
					fail(err.toString() || 'Failed to load creator wise analytics');
				});
		},
		getTrendLine: ({ commit, dispatch } /* payload */) => {
			let fail = msg => commit('failure', msg);
			return dispatch('apiCall', {
				method: 'get',
				params: {
					/* payload */
				},
				url: constants.UTILITY_GET_TREND_LINE,
			})
				.then(data => {
					if (data.ok) {
						return data;
					} else {
						fail(data.message || 'Failed to load trend line');
						return { ok: false };
					}
				})
				.catch(err => {
					console.log('stats load ', err);
					fail(err.toString() || 'Failed to load trend line');
				});
		},
		pushMailLogAndDataLog: ({ commit, dispatch } /* payload */) => {
			let fail = msg => commit('failure', msg);
			return dispatch('apiCall', {
				method: 'get',
				params: {
					/* payload */
				},
				url: constants.UTILITY_PUSH_LOGS,
			})
				.then(data => {
					if (data.ok) {
						return data.ok;
					} else {
						fail(data.message || 'Failed to load trend line');
						return false;
					}
				})
				.catch(err => {
					console.log('stats load ', err);
					fail(err.toString() || 'Failed to load trend line');
				});
		},
		getStockistList: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch('apiCall', {
				method: 'get',
				params: payload,
				url: constants.GET_ALL_STOCKIST,
			})
				.then(data => {
					return data;
				})
				.catch(err => {
					console.log('stats load ', err);
					fail(err.toString() || 'Failed to load stockist list');
				});
		},
		checkPythonScriptConvertable: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch('apiCall', {
				method: 'get',
				params: payload,
				responseType: 'blob',
				url: constants.CHECK_IF_PYTHON_SCRIPT_CONVERTABLE,
			})
				.then(data => {
					return data;
				})
				.catch(err => {
					console.log('api error', err);
					fail(err.toString() || 'Failed to check');
				});
		},
		downloadPythonScriptOutput: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch('apiCall', {
				method: 'get',
				params: payload,
				responseType: 'blob',
				url: constants.DOWNLOAD_PYTHON_SCRIPT_CONVERTABLE_OUTPUT,
			})
				.then(data => {
					return data;
				})
				.catch(err => {
					console.log('api error', err);
					fail(err.toString() || 'Failed to check');
				});
		},
		downloadPDFMLAPIConvertableOutputAPICall: (
			{ commit, dispatch },
			payload
		) => {
			let fail = msg => commit('failure', msg);
			return dispatch('apiCall', {
				method: 'get',
				params: payload,
				responseType: 'blob',
				url: constants.DOWNLOAD_PDF_ML_API_CONVERTABLE_OUTPUT,
			})
				.then(data => {
					return data;
				})
				.catch(err => {
					console.log('api error', err);
					fail(err.toString() || 'Failed to check');
				});
		},
		downloadPDFGeminiConvertableOutputAPICall: (
			{ commit, dispatch },
			payload
		) => {
			let fail = msg => commit('failure', msg);
			return dispatch('apiCall', {
				method: 'get',
				params: payload,
				responseType: 'blob',
				url: constants.DOWNLOAD_PDF_GEMINI_CONVERTABLE_OUTPUT,
			})
				.then(data => {
					return data;
				})
				.catch(err => {
					console.log('api error', err);
					fail(err.toString() || 'Failed to check');
				});
		},
		downloadXlsToXlsxConvertableOutputAPICall: (
			{ commit, dispatch },
			payload
		) => {
			let fail = msg => commit('failure', msg);
			return dispatch('apiCall', {
				method: 'get',
				params: payload,
				responseType: 'blob',
				url: constants.DOWNLOAD_XLS_TO_XLSX_CONVERTABLE_OUTPUT,
			})
				.then(data => {
					return data;
				})
				.catch(err => {
					console.log('api error', err);
					fail(err.toString() || 'Failed to check');
				});
		},
		downloadPythonScriptDelimiterOutput: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch('apiCall', {
				method: 'get',
				params: payload,
				responseType: 'blob',
				url: constants.DOWNLOAD_PYTHON_SCRIPT_DELIMITER_CONVERTABLE_OUTPUT,
			})
				.then(data => {
					return data;
				})
				.catch(err => {
					console.log('api error', err);
					fail(err.toString() || 'Failed to check');
				});
		},
		revertFileToOrignalByUUID({ commit, dispatch }, uuid) {
			let fail = msg => commit('failure', msg);
			let payload = {
				uuid,
				extractManually: true,
			};
			return dispatch(
				'apiCall',
				{
					method: 'put',
					data: payload,
					url: constants.REVERT_TO_ORIGNAL,
				},
				{ root: true }
			)
				.then(data => {
					if (!data.ok) fail(data.message || 'Failed to revert File To Orignal');
					return data;
				})
				.catch(err => {
					fail(err.toString() || 'Failed to revert File To Orignal');
					return {
						ok: false,
						message: err.message,
					};
				});
		},
		revertToMetaNotFoundByUUIDList({ commit, dispatch }, uuidList) {
			let fail = msg => commit('failure', msg);
			let payload = {
				uuids: uuidList,
			};
			return dispatch(
				'apiCall',
				{
					method: 'put',
					data: payload,
					url: constants.REVERT_TO_META_NOT_FOUND,
				},
				{ root: true }
			)
				.then(data => {
					if (!data.ok) fail(data.message || 'Failed to revert file To Meta');
					return data;
				})
				.catch(err => {
					fail(err.toString() || 'Failed to revert file To Meta');
					return {
						ok: false,
						message: err.message,
					};
				});
		},
		async getAIGeneratedHeaderMapping({ commit, dispatch }, payload) {
			let fail = msg => commit('failure', msg);
			return dispatch('apiCall', {
				method: 'get',
				params: payload,
				// responseType: 'blob',
				url: constants.AI_GENERATED_HEADER_MAPPING,
			})
				.then(data => {
					return data;
				})
				.catch(err => {
					console.log('api error', err);
					fail(err.toString() || 'Failed to check');
					return err
				});
		},
	},
	getters: {
		loaderDialog: state => state.loaderDialog,
		selectedDates: state => state.selectedDates,
		snackbarState: state => state.snackbarState,
		snackbarText: state => state.snackbarText,
		snackbarColor: state => state.snackbarColor,
		snackbarTime: state => state.snackbarTime,
		userType: state => state.userType,
		auth: state => state.auth,
		authToken: state => state.authToken,
		userData: state => state.userData,
		mapableHeaders: state => state.mapableHeaders,
		rejectRemarks: state => state.rejectRemarks,
		extensions: state => state.extensions,
		startDay: state => state.startDay,
		getSelectedDates: state => {
			let sDates = JSON.parse(JSON.stringify(state.selectedDates));
			let d = sDates.sort(function(a, b) {
				return a < b ? -1 : a > b ? 1 : 0;
			});
			let startDate = d[0]
				? moment(new Date(d[0]))
						.tz('Asia/Kolkata')
						.startOf('day')
						.toISOString()
				: false;
			let endDate = d[1]
				? moment(new Date(d[1]))
						.tz('Asia/Kolkata')
						.endOf('day')
						.toISOString()
				: false;
			return {
				startDate,
				endDate,
			};
		},
	},
});
